// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__biVWD","main-content":"Layout_main-content__JnZ5K","nav-hide":"Layout_nav-hide__FNaVs"};